import { isFunction } from 'lodash';
import { Fragment, memo, type ReactNode } from 'react';

import type { UseWizard } from '../../../hooks/useWizard';

export type WizardStepChildren =
  | ((params: {
      /** From useWizard. */
      onGoToNextStep: () => void;
      /** From useWizard. */
      onGoToPreviousStep: () => void;
      /** From useWizard. */
      isNextStepDisabled: boolean;
      /** From useWizard. */
      isPreviousStepDisabled: boolean;
    }) => ReactNode)
  | ReactNode;

export type WizardStepProps = UseWizard[0] & {
  /** Name of the step. */
  step: string | string[];
  /**
   * Children rendered if the step is the current step.
   * If children is a function, it is called with callbacks and disabled state for steps buttons.
   */
  children?: WizardStepChildren;
};

export const WizardStepBase = ({
  step,
  onGoToNextStep,
  onGoToPreviousStep,
  isCurrentStep,
  isNextStepDisabled,
  isPreviousStepDisabled,
  children = null,
}: WizardStepProps) => (
  // Need to use jsx otherwise storybook/eslint does not see that this a react component.

  <Fragment>
    {isCurrentStep(step) &&
      (isFunction(children)
        ? children({
            onGoToNextStep,
            onGoToPreviousStep,
            isNextStepDisabled,
            isPreviousStepDisabled,
          })
        : children)}
  </Fragment>
);

WizardStepBase.displayName = 'WizardStep';

export const WizardStep = memo(WizardStepBase);
